<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Notification">
      <div class="row">
        <div class="col-md-6 form-group">
          Notification Type
          <b-form-select v-model="type" @focus="typeEmpty = false">
                <option value="all_users">All Users</option>
            <option value="subscribed_users">Subscribed Users</option>
          </b-form-select>
          <div v-if="typeEmpty" style="color: red">
            Type is required
          </div>
        </div>
       <div class="col-md-6 form-group">
          Title
          <input class="form-control" v-model="title" @focus="titleEmpty = false" type="text" />
          <div v-if="titleEmpty" style="color: red">
            Title is required
          </div>
        </div>
        <div class="col-md-12 form-group">
          Message
          <b-textarea class="form-control" v-model="message" @focus="messageEmpty = false" type="text" />
          <div v-if="messageEmpty" style="color: red">
            Message is required
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="save()"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      type: "",
      typeEmpty: false,
      title: "",
      titleEmpty: false,
      message: "",
      messageEmpty: false,
    };
  },
  methods: {
    async save() {
      if (this.type == "") {
        this.typeEmpty = true;
        return;
      }
      if (this.title == "") {
        this.titleEmpty = true;
        return;
      }
      if (this.message == "") {
        this.messageEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("type", this.type);
      formdata.append("title", this.title);
      formdata.append("message", this.message);
      await axios
        .post(`${this.$store.getters.baseUrl}/notification/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "Notification Has Been Sent Successfully", "success");
            this.$router.push({name: 'Notifications'});
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

